"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGame = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useQuery_1 = require("../useQuery");
var useGame = function (payload) {
    var _a = (0, useQuery_1.useQuery)({
        payload: payload,
        path: keys_1.GAME_INFO,
        revalidateIfStale: true,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading, isValidating = _a.isValidating;
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
        isValidating: isValidating,
    }); }, [data, isLoading, error, isValidating]);
};
exports.useGame = useGame;
